import React from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import { TBaseTagContext } from '../types';
import { TTag } from './types';
import { validate } from '@krugom/validator';
import { toString } from 'lodash';
import { TValidationScheme } from '@krugom/validator/dist/types';

const validationScheme: TValidationScheme = {
  type: 'object',
  properties: {
    children: {
      type: 'string',
      required: true,
    },
  },
};

export const CustomMarkdown: React.FC<{
  tagProps: TTag;
  context: Partial<TBaseTagContext>;
}> = React.memo(({ tagProps, context }) => {
  const result = validate(tagProps, validationScheme);

  if (!result.isValid) {
    console.error(
      'Тэг: $Markdown;',
      `Путь: ${context.path?.join('.') || 'Не указан'};`,
      result.errors
    );
    return <>{toString(tagProps.children)}</>;
  }

  return (
    <ReactMarkdown rehypePlugins={tagProps.raw ? [rehypeRaw] : undefined}>
      {`${tagProps.children}`}
    </ReactMarkdown>
  );
});

CustomMarkdown.displayName = 'CustomMarkdown';
